import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { DEVICES } from '_constants';
import { deviceLess } from '_constants/DEVICES';
import { CLOSE_MODAL_ICON } from 'assets/icons';
import { UiColors } from 'assets/styles/old/global';

// Width of the docked panel, and the <body> flag raised while it is open. Both are exported because
// the map has to push its right-hand Leaflet controls (zoom / basemap / pegman / full-screen) out
// from under the panel — see MapWrapper in ui-kit/TableTabsWrapper/old.styles.js, which reads the
// class plus the --map-popup-docked-width custom property this width is written to.
export const MAP_POPUP_WIDTH = 474;
export const MAP_POPUP_DOCKED_CLASS = 'map-popup-docked';

export const WrapperName = styled(Link)`
  /* Same token as the visit-table date links (modules/old/cells/LinkCell). Hardcoding the legacy
     indigo left the title purple against the redesign's blue rows, since --link-color switches to
     --dodger-blue under data-new-ui; via the token both move together and the old UI is unchanged. */
  color: var(--link-color);
  font-size: 14px;
  text-decoration: underline;
  margin-bottom: 20px;
  display: block;
  cursor: pointer;
  font-weight: 600;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  display: block;
  width: 15px;
  height: 15px;
  background: url(${CLOSE_MODAL_ICON});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 15px;
  font-size: 0;
  border: none;
`;
export const Wrapper = styled.div`
  position: fixed;
  left: 0;
  top: 54px;
  z-index: 10;
  overflow: hidden;
  max-width: ${MAP_POPUP_WIDTH}px;
  width: 100%;
  height: calc(100% - 54px);
  padding-top: 50px;
  background-color: var(--white);

  /* New UI only. The old chrome was full-width, so the panel could hug left: 0; the new one puts a
     fixed nav rail there, which swallowed the first 56-84px of the panel. Dock it to the right edge
     instead of shifting it past the rail: that also clears the map's top-left "Map Features" panel
     and the page's own view sidebar, so everything stays visible at once. Only above the rail's
     900px breakpoint — narrower than that there is no rail and the panel goes full-width as before. */
  ${({ $docked, $topOffset }) =>
    $docked &&
    css`
      @media ${deviceLess.tableView} {
        left: auto;
        right: 0;
        top: ${$topOffset}px;
        bottom: 0;
        /* top + bottom own the height; the old calc() ignored padding-top and overflowed the
           viewport, which is what cut the bottom off the visit table. */
        height: auto;
        box-sizing: border-box;
        z-index: 140;
        box-shadow: -4px 0 16px rgba(0, 0, 0, 0.12);
      }
    `}

  label {
    font-size: 14px;
  }

  ${WrapperName}:first-of-type {
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
  }
`;

export const SecondTable = styled.div`
  box-sizing: border-box;
  padding: 0 20px 20px;

  label {
    font-size: 16px;
  }

  .rt-th {
    button {
      svg {
        display: none;
      }
    }
  }
`;

export const ThirdTable = styled.div`
  margin: 20px 0;
  box-sizing: border-box;
  padding: 0 10px;

  label {
    font-size: 16px;
  }
`;

export const WrapperHeaders = styled.div`
  margin: 0 24px 24px 24px;

  @media ${DEVICES.tablet} {
    margin: 35px 0px 0px 24px;
  }
  @media ${DEVICES.mobileL} {
    margin: 35px 0px 0px 10px;
  }
`;

export const StyleAddress = styled.div`
  color: var(--dark);
  font-size: 14px;
  margin-bottom: 35px;
`;

export const StyleSuspencions = styled.div`
  color: ${UiColors.orangeColor};
  font-size: 14px;

  & + & {
    padding-top: 10px;
  }
`;

export const FlexDiv = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: row nowrap;

  > button {
    flex: 1 0;
    padding: 0 10px;

    :not(:last-of-type) {
      margin-right: 10px;
    }
  }
`;

export const Header = styled.div`
  display: none;

  @media ${DEVICES.tablet} {
    display: block;
    background: var(--white-smoke);
    height: 56px;
    padding: 16px;
    box-sizing: border-box;
    top: 1px;
    position: absolute;
    z-index: 1;
    width: 100vw;
    left: 0;
  }

  @media ${DEVICES.mobileL} {
    width: 100%;
    height: auto;

    box-sizing: border-box;
    padding: 10px;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-left: 7px;

  @media ${DEVICES.mobileL} {
    margin-left: 0px;
  }
`;

export const TableTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 10px;
`;
